import { Box } from '@chakra-ui/react';
import ContentLoader from 'react-content-loader';

export const Loading = ({ props }) => (
  <Box>
    <ContentLoader
      speed={2}
      width={250}
      height={200}
      viewBox="0 0 250 200"
      {...props}
    >
      <rect x="0" y="10" rx="3" ry="3" width="200" height="10" />
      <rect x="0" y="30" rx="3" ry="3" width="150" height="10" />

      <rect x="0" y="70" rx="3" ry="3" width="200" height="10" />
      <rect x="0" y="90" rx="3" ry="3" width="150" height="10" />

      <rect x="0" y="130" rx="3" ry="3" width="200" height="10" />
      <rect x="0" y="150" rx="3" ry="3" width="150" height="10" />
    </ContentLoader>
  </Box>
);
